import List from './views/List.vue'
import CreateEdit from './views/CreateEdit.vue'
import Get from './views/Get.vue'

export const LoansRoutes = [
  {
    path: '/loans',
    name: 'ListLoans',
    component: List,
    meta: {
      auth: true,
      layout: 'home',
      permission: 'loan:list'
    }
  },
  {
    path: '/loan',
    name: 'CreateLoan',
    component: CreateEdit,
    meta: {
      auth: true,
      layout: 'home',
      permission: 'loan:create'
    }
  },
  {
    path: '/loan/:id',
    name: 'UpdateLoan',
    component: CreateEdit,
    meta: {
      auth: true,
      layout: 'home',
      permission: 'loan:update'
    }
  },
  {
    path: '/loan/view/:id',
    name: 'GetLoan',
    component: Get,
    meta: {
      auth: true,
      layout: 'home',
      permission: 'loan:get'
    }
  }
]
